import { DASHBOARD_ROUTES } from "../homeDashboard/dashboardRoutes";
import { ONBOARDING_ROUTES } from "../onboarding/onboardingRoutes";
import { AUTH_ROUTES } from "./authRoutes";
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FullScreenLoader from './FullScreenLoader';

function GuestRoute({ children }) {
  const location = useLocation();
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <FullScreenLoader />;
  }

  if (isAuthenticated) {
    const isVerifiedSignup = location.pathname === AUTH_ROUTES.verification && location.state?.source === 'signup';
    return <Navigate to={isVerifiedSignup ? ONBOARDING_ROUTES.states : DASHBOARD_ROUTES.home} replace />;
  }

  return children;
}

export default GuestRoute;
